// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UEAehUJWzBN8u0 {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.SNF_ReUlxVFi6q {
  display: flex;
  justify-content: center;
}
.SchrCZPF9qldFo {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.u9xoRwyCQVpQ7G {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.jKdoBftPgbeSa_ {
  font-style: italic;
}
.ZGXP5CEtnuseQd {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.KOBK4NzQTNbBtW {
  display: flex;
  align-items: center;
  justify-content: center;
}
.p05S3DwjLJChba {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.p05S3DwjLJChba .OcGvYDgiEbNb0x {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.RJA9gyvPyy1PEc {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.RJA9gyvPyy1PEc button {
  margin-left: var(--ds-space-100, 8px);
}
.TNuDDarVzVDzir {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .ZGXP5CEtnuseQd {
    padding: var(--ds-space-200, 16px);
  }
}
.HCFe8Alss_sJeA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.MY9t8hblFX0BpR {
  padding: var(--ds-space-250, 20px) var(--ds-space-300, 24px);
  background-color: var(--ds-surface, #ffffff);
}
.QrNVX8JsI4tsed {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--ds-space-250, 20px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `UEAehUJWzBN8u0`,
	"flexAndCenter": `SNF_ReUlxVFi6q`,
	"body": `SchrCZPF9qldFo`,
	"navigationAndContent": `u9xoRwyCQVpQ7G`,
	"learnMoreSubtle": `jKdoBftPgbeSa_`,
	"content": `ZGXP5CEtnuseQd`,
	"spinnerContainer": `KOBK4NzQTNbBtW`,
	"header": `p05S3DwjLJChba`,
	"title": `OcGvYDgiEbNb0x`,
	"footer": `RJA9gyvPyy1PEc`,
	"formFooter": `TNuDDarVzVDzir`,
	"createNewApplication": `HCFe8Alss_sJeA`,
	"dialog": `MY9t8hblFX0BpR`,
	"modalFooter": `QrNVX8JsI4tsed`
};
export default ___CSS_LOADER_EXPORT___;
